module.exports = __webpack_public_path__ + "img/28.d87bb352.png";